(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-mini-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nufs-mini-countdown')) {
    customElements.define(
      'nufs-mini-countdown',
      class extends HTMLElement {
        connectedCallback() {
          this.digits = this.querySelector('.nfs-mini-cd__digits')
          this.hours = this.querySelector('[data-hours]')
          this.hoursSeparator = this.querySelector('[data-hours-separator]')
          this.minutes = this.querySelector('[data-minutes]')
          this.seconds = this.querySelector('[data-seconds]')
          this.duration = Math.max(0, (Number(this.dataset.durationMinutes) || 0) * 60 + (Number(this.dataset.durationSeconds) || 0))
          this.storageKey = 'nfs-countdown-start:' + this.dataset.blockId + ':' + this.duration
          this.start = Date.now()
          if (this.dataset.timerMode !== 'midnight') {
            try {
              const stored = Number(localStorage.getItem(this.storageKey))
              if (Number.isFinite(stored) && stored > 0 && stored <= this.start) {
                this.start = stored
              } else {
                localStorage.setItem(this.storageKey, String(this.start))
              }
            } catch (error) {
              // Keep counting in memory when browser storage is unavailable.
            }
          }
          this.tick()
          this.digits.hidden = false
          this.intervalId = setInterval(() => this.tick(), 1000)
        }

        disconnectedCallback() {
          clearInterval(this.intervalId)
        }

        tick() {
          let remaining = 0
          if (this.dataset.timerMode === 'midnight') {
            const now = new Date()
            const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1)
            remaining = Math.ceil((midnight - now) / 1000)
          } else if (this.duration > 0) {
            const elapsed = Math.max(0, Math.floor((Date.now() - this.start) / 1000))
            remaining = this.duration - (elapsed % this.duration)
          }
          const showHours = this.dataset.timerMode === 'midnight' || this.duration >= 3600
          this.hours.hidden = !showHours
          this.hoursSeparator.hidden = !showHours
          this.hours.textContent = String(Math.floor(remaining / 3600)).padStart(2, '0')
          this.minutes.textContent = String(Math.floor(remaining / 60) % 60).padStart(2, '0')
          this.seconds.textContent = String(remaining % 60).padStart(2, '0')
        }
      }
    )
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["size-and-frame-guide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const frame = document.querySelector('.size-guide-playground__frame')
    const sizeButtons = document.querySelectorAll('.size-guide-playground__options-button')
    let activeSizeData = null

    const handleSizeChange = (button) => {
      sizeButtons.forEach((btn) => btn.classList.remove('active'))
      button.classList.add('active')

      const sizeValue = button.getAttribute('data-size')

      if (window.sizeList) {
        activeSizeData = window.sizeList.find((item) => item.metric === sizeValue)
      }

      if (activeSizeData && frame) {
        const unit = window.unitSystem
        const sizeString = activeSizeData[unit]

        if (sizeString) {
          const [short, long] = sizeString.split('x')
          const [shortMetric, longMetric] = activeSizeData['metric'].split('x')

          frame.setAttribute('data-size', activeSizeData['metric'])
          frame.style.setProperty('--frame-long-side', longMetric)
          frame.style.setProperty('--frame-short-side', shortMetric)
          frame.style.setProperty('--frame-aspect-ratio', shortMetric / longMetric)

          let text = ''
          if (unit === 'metric') {
            text = `'${short}cm x ${long}cm'`
          } else {
            text = `'${short}" x ${long}"'`
          }
          frame.style.setProperty('--frame-size', text)
        }
      }
    }

    sizeButtons.forEach((button) => {
      button.addEventListener('click', function () {
        handleSizeChange(this)
      })
    })

    const defaultButton = document.querySelector('.size-guide-playground__options-button[data-size="100x150"]')
    if (defaultButton) handleSizeChange(defaultButton)
  })
  } catch(e) { console.error(e); }
})();

})();
